<template>
  <header v-if="!menuOpen" :class="['glass-topbar', 'glass-topbar--wordmark', 'organizer-workspace-topbar', { 'is-scrolled': isScrolled }]">
    <router-link class="glass-topbar__brand glass-topbar__brand--wordmark organizer-workspace-topbar__brand" :to="brandRoute">
      <img class="glass-topbar__brand-logo organizer-workspace-topbar__logo" src="/static/LOGOFOMO26_pro.png" alt="Fomo Planes" />
    </router-link>

    <button class="glass-topbar__menu-button organizer-workspace-topbar__menu" type="button" :aria-label="menuLabel" @click="$emit('open-menu')">
      <i class="fas fa-bars"></i>
    </button>
  </header>
</template>

<script>
export default {
  name: 'OrganizerWorkspaceTopbar',

  props: {
    menuLabel: {
      type: String,
      default: 'Abrir menú del organizador',
    },

    menuOpen: {
      type: Boolean,
      default: false,
    },

    brandRoute: {
      type: [Object, String],
      default: () => ({ name: 'events2' }),
    },
  },

  emits: ['open-menu'],

  data() {
    return {
      isScrolled: false,
    }
  },

  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      this.isScrolled = (window.scrollY || window.pageYOffset || 0) > 18
    },
  },
}
</script>

<style scoped>
.organizer-workspace-topbar {
  display: none;
}

@media (max-width: 980px) {
  .organizer-workspace-topbar {
    position: sticky;
    top: 12px;
    z-index: 45;
    display: grid !important;
    grid-template-columns: 40px minmax(0, 1fr) 40px;
    align-items: center;
    gap: 8px;
    width: min(1440px, 100%);
    margin: 0 auto 12px;
    padding: 10px 12px;
    border-radius: 22px;
    opacity: 1;
    pointer-events: auto;
    transform: none;
    transition: opacity 0.22s ease, transform 0.22s ease;
  }

  .organizer-workspace-topbar::before {
    content: '';
    width: 40px;
    height: 40px;
  }

  .organizer-workspace-topbar__brand {
    grid-column: 2;
    justify-self: center;
    min-width: 0;
    max-width: 208px;
  }

  .organizer-workspace-topbar__logo {
    display: block;
    width: 100%;
    height: auto;
    filter: drop-shadow(0 10px 24px rgba(142, 111, 198, 0.22));
  }

  .organizer-workspace-topbar__menu {
    grid-column: 3;
    justify-self: end;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    border-radius: 14px;
  }
}

@media (max-width: 720px) {
  .organizer-workspace-topbar__brand {
    max-width: 182px;
  }
}
</style>
